function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Path_200",
  "data-name": "Path 200",
  d: "M846.4,434a1.1,1.1,0,0,1,1.072.852l1.071,4.648H862.9a1.1,1.1,0,0,1,1.067,1.367l-2.2,8.8a1.1,1.1,0,0,1-1.067.833h-11a1.1,1.1,0,0,1-1.072-.852l-3.1-13.448H842V434Zm4.174,14.3h9.266l1.65-6.6H849.052Z",
  transform: "translate(-842 -433.999)",
  fill: "#fff"
});

var _ref3 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_156",
  "data-name": "Ellipse 156",
  cx: 2.5,
  cy: 2,
  rx: 2.5,
  ry: 2,
  transform: "translate(14.999 18)",
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  id: "Ellipse_157",
  "data-name": "Ellipse 157",
  cx: 2,
  cy: 2,
  rx: 2,
  ry: 2,
  transform: "translate(6.999 18)",
  fill: "#fff"
});

function SvgCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_105",
    "data-name": "Group 105",
    width: 21.999,
    height: 22,
    viewBox: "0 0 21.999 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.cfc18c08.svg";
export { ForwardRef as ReactComponent };